import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const MAXIMUM_CACHE_COUNT = 1000

interface CacheEntry {
    funcName: string
    params: string | null
    data: any
}
type CacheStateEntry = Record<string, Record<string, any>>

export interface CacheState {
    order: string[]
    entry: CacheStateEntry
}

const initialState: CacheState = {
    order: [],
    entry: {} as CacheStateEntry,
}

const cacheSlice = createSlice({
    name: 'cache',
    initialState,
    reducers: {
        updateCache: (state: CacheState, action: PayloadAction<CacheEntry>) => {
            const { funcName, params, data } = action.payload
            if (!params) {
                return
            }

            // With Immer in RTK, we can safely "mutate" state
            if (!state.entry[funcName]) {
                state.entry[funcName] = {}
            }

            // Update the cache entry
            state.entry[funcName][params] = data

            // Add to order list
            const cacheKey = `${funcName}.${params}`
            state.order.push(cacheKey)

            // Prune oldest entries if over limit
            if (state.order.length > MAXIMUM_CACHE_COUNT) {
                const item = state.order.shift()
                if (item) {
                    // Parse the item key back into function name and params
                    const [itemFuncName, itemParams] = item.split('.')
                    if (state.entry[itemFuncName]?.[itemParams]) {
                        delete state.entry[itemFuncName][itemParams]
                    }
                }
            }
        },

        invalidateCache: (state: CacheState) => {
            state.order = []
            state.entry = {}
        },
    },
})

// Export actions and reducer
export const { updateCache, invalidateCache } = cacheSlice.actions
export default cacheSlice.reducer
